import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { EnrollmentCommentInput } from '../../../../lib/types/models/enrollment-comment/enrollment-comment-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../elements/validation-buttons'

const ENROLLMENT_COMMENT_SCHEMA: ZodType<EnrollmentCommentInput> = z.object({
  comment: createStringSchema('commentaire')
})

const EnrollmentCommentForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<EnrollmentCommentInput>) => {
  const form = useForm<EnrollmentCommentInput>({
    resolver: zodResolver(ENROLLMENT_COMMENT_SCHEMA),
    defaultValues,
    mode: FORM_MODE
  })
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="flex flex-col gap-4 p-4"
      >
        <FormField
          control={form.control}
          name={'comment'}
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} type="textarea" label="Commentaire" />
              </FormControl>
            </FormItem>
          )}
        />

        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default EnrollmentCommentForm
